import ni from '../data/node-index';

let indexAnalyser = {
  exeAnalyser : node=>{
    let $analyser = $('.ui-node-analyser');
    if(!$analyser.length){
      $analyser = $(`<div class="ui-node-analyser ui-modal">
        <span class="modal-close">&times;</span>
        <h5>Text to Analyse</h5>
        <input type="text" maxlength="25" placeholder="">
        <button type="button">OK</button>
      </div>`);
      $analyser.find('.modal-close').click(()=>{
        $analyser.hide()
      });
      $('body').append($analyser);
    }else{
      $analyser.find('input[type=text]').val('');
      $analyser.show();
    }
    $analyser.find('button').off('click').on('click', ()=>{
      ni.analyser(node, `text=${encodeURIComponent($analyser.find('input[type=text]').val())}`);
      $analyser.hide();
    });
  }
}

export default indexAnalyser;


// WEBPACK FOOTER //
// ./src/scripts/ui/index-analyser.js